import React from 'react';
import {
  ApButtonGroup,
  ApButtonDanger,
  ApButtonSecondary,
} from '@alixpartners/ui-components';
import {
  StyledModal,
  TextContent,
} from 'components/ClassificationRules/DeleteConfirmationModal/DeleteConfirmationModal.styles';

interface IProps {
  isOpen: boolean;
  onDelete(): void;
  onClose(): void;
  blendName: string;
}

export const DeleteBlendConfirmationModal: React.FC<IProps> = ({
  isOpen,
  onDelete,
  onClose,
  blendName,
}) => {
  return (
    <StyledModal
      isOpen={isOpen}
      header="Delete Industry blend"
      isDismissible
      hasClosed={onClose}
      footer={() => {
        return (
          <ApButtonGroup justifyContent="flex-end">
            <ApButtonSecondary onClick={onClose}>Cancel</ApButtonSecondary>
            <ApButtonDanger onClick={onDelete}>Delete</ApButtonDanger>
          </ApButtonGroup>
        );
      }}
    >
      <TextContent>
        Do you really want to delete <strong>{blendName}</strong>?
      </TextContent>
    </StyledModal>
  );
};
